<template>
  <v-list>
    <v-list-item dense>
      <v-list-item-content>
        Grundfläche
      </v-list-item-content>
      {{ textTotalArea }}
    </v-list-item>
    <v-divider/>
    <v-list-item
      :disabled="gewerblich"
    >
      <v-list-item-content>
       Volumen Dach
      </v-list-item-content>
      {{ textVolumeRoof }}
    </v-list-item>
    <v-list-item
        dense
        :disabled="gewerblich"
    >
      <v-list-item-content>
        Volumen Gebäude
      </v-list-item-content>
        {{ textVolumeGebaeude }}
    </v-list-item>
    <v-list-item
        dense
       :disabled="gewerblich"
    >
      <v-list-item-content>
        Volumen Keller
      </v-list-item-content>
      {{ textVolumeBasement }}
    </v-list-item>
    <v-list-item dense :disabled="gewerblich">
      <v-list-item-content>
        Volumen Gesamt
      </v-list-item-content>
      {{ textVolumeTotal }}
    </v-list-item>
    <v-divider/>
    <v-list-item dense>
      <v-list-item-content>
        Herstellungswert je {{gewerblich ? 'm²' : 'm³' }}
      </v-list-item-content>
        {{ textHerstellungswert}}
    </v-list-item>
    <v-divider/>
    <v-list-item dense>
      <v-list-item-content>
        Korrekturfaktor
      </v-list-item-content>
      {{ textCorrectionFactor }}
    </v-list-item>
    <v-divider/>
    <v-list-item dense>
        <v-list-item-content>
          <b>Herstellungswert Gebäude</b>
        </v-list-item-content>
          <b>
            {{ textFinalResult }}
          </b>
    </v-list-item>
  </v-list>
</template>

<script>
/**
 * Displays the results.
 */
export default {
  props: [
    'gewerblich',
    'totalArea',
    'volumeRoof',
    'volumeBuilding',
    'volumeBasement',
    'totalVolume',
    'herstellungswert',
    'correctionFactor',
    'finalResult',
  ],
  computed: {
    textTotalArea () {
      return this.germanNumber(this.totalArea.toFixed(2)) + ' m²' || '';
    },
    textVolumeRoof () {
      if (this.gewerblich) {
        return '';
      } else {
        return this.volumeRoof ? this.germanNumber(this.volumeRoof.toFixed(2)) + ' m³' : '';
      }
    },
    textVolumeGebaeude () {
      if (this.gewerblich) {
        return '';
      } else {
        return this.volumeBuilding ? this.germanNumber(this.volumeBuilding.toFixed(2)) + ' m³' : '';
      }
    },
    textVolumeBasement () {
      if (this.gewerblich) {
        return '';
      } else {
        return this.volumeBasement ? this.germanNumber(this.volumeBasement.toFixed(2)) + ' m³' : ''
      }
    },
    textVolumeTotal () {
       if (this.gewerblich) {
        return '';
      } else {
        return this.totalVolume ? this.germanNumber(this.totalVolume.toFixed(2)) + ' m³' : '';
      }
    },
    textHerstellungswert () {
      return this.herstellungswert ? this.herstellungswert.toFixed(0) + ' €' : '';
    },
    textCorrectionFactor () {
      return this.germanNumber(this.correctionFactor.toFixed(1), 2);
    },
    textFinalResult () {
      var euroFormatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      });

      return this.finalResult ? euroFormatter.format(this.finalResult.toFixed(0)): '';
    }
  },
  methods: {
    germanNumber(number, minDigits) {
      if (minDigits) {
        // show at least x digits after comma, for minDigits=2: 1 => 1,0
        return new Intl.NumberFormat('de-DE', {minimumSignificantDigits: minDigits}).format(number);
      }
      return new Intl.NumberFormat('de-DE').format(number)
    }
  }
};
</script>
